module.exports = __webpack_public_path__ + "img/avatar-300-cameraman-kneeling.5e6f1381.png";